import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = "adminSession";

// The admin identity mirrors what the PHP admin kept in $_SESSION:
// sessionId / userId / organizationId (+ gameId). Superadmin is sessionId = organizationId = "admin".
export function saveAdminSession(session) {
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function getAdminSession() {
  try {
    const session = JSON.parse(sessionStorage.getItem(SESSION_KEY));
    return session && session.sessionId && session.organizationId ? session : null;
  } catch {
    return null;
  }
}

export function clearAdminSession() {
  sessionStorage.removeItem(SESSION_KEY);
}

export const isSuperAdmin = (session) => session?.sessionId === "admin";

// Backend auth is "Authorization: Bearer <sessionId>&<organizationId>"
function authHeaders(session) {
  return { Authorization: `Bearer ${session.sessionId}&${session.organizationId}` };
}

/** POST JSON (or FormData for uploads) to an admin endpoint. Resolves with response body; rejects with Error(message). */
export async function adminPost(path, body = {}, session = getAdminSession()) {
  if (!session) throw new Error("Admin session expired. Please open the admin again.");
  try {
    const res = await axios.post(`${BASE_URL}/${path}`, body, { headers: authHeaders(session) });
    return res.data;
  } catch (err) {
    const data = err.response?.data;
    throw new Error(data?.message || data?.error || err.message || "Request failed");
  }
}

export async function superadminLogin(password) {
  try {
    const res = await axios.post(`${BASE_URL}/superadminLogin`, { password });
    return res.data;
  } catch (err) {
    throw new Error(err.response?.data?.message || "Login failed");
  }
}

// Image helpers shared by the upload forms
export const readImageSize = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve([img.width, img.height]);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Failed to load image"));
    };
    img.src = url;
  });
